<script>
import LongFormContent from './dynamicContentTypes/LongFormContent.vue';
import ProductRecommendations from './dynamicContentTypes/ProductRecommendations.vue';
import ProductRecommendationsGendered from './dynamicContentTypes/ProductRecommendationsGendered.vue';
import MultipleProductRecommendations from './dynamicContentTypes/MultipleProductRecommendations.vue';

export default {
  name: 'RenderDynamicContent',
  components: {
    LongFormContent,
    ProductRecommendations,
    ProductRecommendationsGendered,
    MultipleProductRecommendations,
  },
  props: {
    component: {
      required: false,
      type: String,
      default: 'div',
    },
    data: {
      required: true,
      type: Object,
    },
    reviewContent: {
      type: Object,
      default: () => {},
    },
    id: {
      required: false,
      type: String,
      default: null,
    },
  },
  computed: {
    getMergedObject() {
      const addId = {
        headerId: this.id,
      };
      return { ...this.data, ...this.reviewContent, ...addId };
    },
  },
};
</script>

<template>
  <component
    :is="component"
    v-bind="getMergedObject"
  />
</template>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';
@import '@rei/cdr-component-variables/dist/scss/index.scss';

table.table {
  @include cdr-table-base-mixin;
}

</style>
